<template>
  <date-range-picker
    v-model="dateRange"
    ref="thiscalendar"
    :locale-data="{ firstDay: 0, format: 'DD-MM-YYYY' }"
    @select="predateselected"
    single-date-picker
    opens="inline"
    :ranges="customRanges"
    :show-week-numbers="true"
    :linked-calendars="false"
    :show-dropdowns="false"
  >
    <!--    header slot-->

    <!--    input slot (new slot syntax)-->
    <template #input="picker" style="min-width: 350px">
      {{ picker.startDate.toLocaleDateString() }} -
      {{ picker.endDate.toLocaleDateString() }}
    </template>
    <!--    ranges (new slot syntax) -->
    <template #ranges="ranges">
      <div class="ranges" v-show="false">
        <ul>
          <li
            v-for="(range, name) in ranges.ranges"
            :key="name"
            @click="ranges.clickRange(range)"
          >
            <b>{{ name }} </b> <br /><small class="text-muted"
              >{{ range[0].toDateString() }} -
              {{ range[1].toDateString() }}</small
            >
          </li>
        </ul>
      </div>
    </template>
    <!--    footer slot-->
    <div slot="footer" class="slot">
      <div>Please select a date for comparison</div>
    </div>
  </date-range-picker>
</template>

<script>
import DateRangePicker from "../calendar/components/DateRangePicker.vue";

import "../assets/style.css";
import moment from "moment";
// localization is optional

export default {
  name: "CalendarNoFooter",
  props: {
    pbyWeek: Boolean,
    pbyMonth: Boolean,
    pbyRange: Boolean,
    pbyDay: Boolean,
    dateselected: Function,
  },
  data() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    let startDate = new Date();
    let endDate = new Date();
    endDate.setDate(endDate.getDate() + 6);
    return {
      today: today,
      byDay: false,
      byRange: false,
      byWeek: false,
      byMonth: false,
      pickedBy: "",
      customRanges: {},
      normalcustomRanges: {
        Today: [today, today],
        Yesterday: [yesterday, yesterday],
        "This month": [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(today.getFullYear(), today.getMonth() + 1, 0),
        ],
        "This year": [
          new Date(today.getFullYear(), 0, 1),
          new Date(today.getFullYear(), 11, 31),
        ],
        "Last month": [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
      },
      byWeekscustomRanges: {},
      byMonthscustomRanges: {},
      dateRange: { startDate, endDate },
    };
  },
  components: {
    DateRangePicker,
  },
  watch: {
    pbyWeek: {
      handler: function () {
        this.dateRange.startDate = this.today;
        this.dateRange.endDate = this.today;
        this.byWeek = this.pbyWeek;
      },
      deep: true,
    },
    pbyDay: {
      handler: function () {
        this.dateRange.startDate = this.today;
        this.dateRange.endDate = this.today;
        this.byDay = this.pbyDay;
      },
      deep: true,
    },

    pbyRange: {
      handler: function () {
        this.dateRange.startDate = this.today;
        this.dateRange.endDate = this.today;
        this.byRange = this.pbyRange;
      },
      deep: true,
    },
    pbyMonth: {
      handler: function () {
        this.dateRange.startDate = this.today;
        this.dateRange.endDate = this.today;
        this.byMonth = this.pbyMonth;
      },
      deep: true,
    },
  },
  methods: {
    predateselected(range) {
      if (this.pbyWeek) {
        this.dateRange.startDate = moment(range.startDate)
          .startOf("week")
          .toDate();
        this.dateRange.endDate = moment(range.startDate).endOf("week").toDate();
      } else if (this.pbyMonth) {
        this.dateRange.startDate = moment(range.startDate)
          .startOf("month")
          .toDate();
        this.dateRange.endDate = moment(range.startDate)
          .endOf("month")
          .toDate();
      } else if (this.pbyRange) {
        this.dateRange.startDate = range.startDate;
        this.dateRange.endDate = range.endDate;
      } else if (this.pbyDay) {
        this.dateRange.startDate = range.startDate;
        this.dateRange.endDate = range.startDate;
      }
      this.dateselected(this.dateRange);
    },
    getDateRangeOfWeek(weekNo) {
      weekNo = weekNo + 1;
      var d1 = new Date();
      d1.setHours(0, 0, 0, 0);
      var d2 = new Date();
      d2.setHours(0, 0, 0, 0);
      var numOfdaysPastSinceLastMonday = eval(d1.getDay() - 1);
      d1.setDate(d1.getDate() - numOfdaysPastSinceLastMonday);
      //console.log(d1);
      var weekNoToday = d1.getWeek();
      var weeksInTheFuture = eval(weekNo - weekNoToday);

      d2.setDate(d1.getDate() + eval(7 * (weeksInTheFuture + 1)) - 1);
      d1.setDate(d1.getDate() + eval(7 * weeksInTheFuture));

      // var rangeIsFrom = eval(d1.getMonth()+1) +"/" + d1.getDate() + "/" + d1.getFullYear();

      //  var rangeIsTo = eval(d1.getMonth()+1) +"/" + d1.getDate() + "/" + d1.getFullYear() ;
      return [d1, d2];
    },
    getDateRangeOfMonths(monthNo) {
      var d1 = new Date();
      d1 = new Date(d1.getFullYear(), monthNo, 1);
      d1.setHours(0, 0, 0, 0);
      var d2 = new Date(d1.getFullYear(), monthNo + 1, 1);

      //  var rangeIsTo = eval(d1.getMonth()+1) +"/" + d1.getDate() + "/" + d1.getFullYear() ;
      return [d1, d2];
    },
    setdateRange(startDate,endDate){
      this.dateRange.startDate=startDate;
      this.dateRange.endDate=endDate;

    },
    close() {
      console.log("closing left");
      this.$refs.thiscalendar.opens = "center";

      this.$refs.thiscalendar.togglePicker(false);
    },
  },
  mounted() {
    this.customRanges = this.normalcustomRanges;
    for (let i = 1; i <= 52; i++) {
      var range = this.getDateRangeOfWeek(i);
      // console.log(range);
      this.byWeekscustomRanges[
        "Week " + (range[0].getWeek() - 1).toString()
      ] = range;
    }
    var months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    for (let i = 0; i < 12; i++) {
      this.byMonthscustomRanges[months[i]] = this.getDateRangeOfMonths(i);
    }
  },
  filters: {
    date(val) {
      return val ? val.toLocaleString() : "";
    },
  },
};
Date.prototype.getWeek = function () {
  var onejan = new Date(this.getFullYear(), 0, 1);
  return Math.ceil(((this - onejan) / 86400000 + onejan.getDay() + 1) / 7);
};
</script>

<style scoped>
.slot {
  background-color: #aaa;
  padding: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-black {
  color: #000;
}
.ranges {
  float: left;
  height: 241px;
  overflow-y: scroll;
}
</style>
